export enum buildingControlEnum {
    WaitingSubmit = 'รายการจัดซื้อจัดจ้าง',
    Donate = 'รายการรับบริจาค',
    Transfer = 'รายการรับโอน',
    Discovered = 'รายการสำรวจพบ',
    WaitTransfer = 'รายการรอโอน'
}


export enum buildingRegistrationEnum {
    WaitingSubmit = 'รายการอาคารและสิ่งปลูกสร้าง',
    Donate = 'รับบริจาค',
    Transfer = 'รับโอน',
    Discovered = 'สำรวจพบ'
}

export enum buildingRegistrationDetailsEnum {
    WaitingSubmit = 'ข้อมูล',
    Donate = 'ทะเบียนคุมห้อง',
    Transfer = 'ประวัติอาคารและสิ่งปลูกสร้าง (ยืม-คืน)',
    Discovered = 'การซ่อมแซมและบำรุงรักษา'
}